// extracted by mini-css-extract-plugin
module.exports = {"container":"sideBar_container__1URhr","active":"sideBar_active__24-hb","logo":"sideBar_logo__3kPZR","icon-container":"sideBar_icon-container__3Eali","icon":"sideBar_icon__CAmZ9"};